// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__yl3k1","subfooter":"Footer_subfooter__YZSqx","logo":"Footer_logo__ZIHpg","container":"Footer_container__MaumR","item":"Footer_item__9gMMy"};